/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type CreateMatterInput = {
    assignees: Array<AssigneeRename | null>;
    clientMutationId: string;
    dueDate?: string | null;
    language?: string | null;
    statusId?: string | null;
    statusIdentifier?: string | null;
    tags?: Array<string | null> | null;
    tenantId: string;
    title: string;
};
export type AssigneeRename = {
    assigneeId: string;
    roleId?: string | null;
    roleIdentifier?: string | null;
};
export type MatterCreatorDrawerMutationVariables = {
    input: CreateMatterInput;
};
export type MatterCreatorDrawerMutationResponse = {
    readonly createMatter: {
        readonly errors: ReadonlyArray<{
            readonly code: string | null;
            readonly path: ReadonlyArray<string | null> | null;
            readonly message: string | null;
        } | null> | null;
        readonly matter: {
            readonly id: string;
        } | null;
    } | null;
};
export type MatterCreatorDrawerMutation = {
    readonly response: MatterCreatorDrawerMutationResponse;
    readonly variables: MatterCreatorDrawerMutationVariables;
};



/*
mutation MatterCreatorDrawerMutation(
  $input: CreateMatterInput!
) {
  createMatter(input: $input) {
    errors {
      code
      path
      message
    }
    matter {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateMatterPayload",
            "kind": "LinkedField",
            "name": "createMatter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "InputError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Matter",
                    "kind": "LinkedField",
                    "name": "matter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MatterCreatorDrawerMutation",
            "selections": (v1 /*: any*/),
            "type": "RootMutationType",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MatterCreatorDrawerMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "1d475711f9063bbb16a41b02b66dc2b5",
            "id": null,
            "metadata": {},
            "name": "MatterCreatorDrawerMutation",
            "operationKind": "mutation",
            "text": "mutation MatterCreatorDrawerMutation(\n  $input: CreateMatterInput!\n) {\n  createMatter(input: $input) {\n    errors {\n      code\n      path\n      message\n    }\n    matter {\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'cfe0360f094ea045df2bda4e5b2478e2';
export default node;
